import React from 'react';
import StandardAIDetail from './StandardAIDetail';

// Custom template for Risk & Confidence - can be customized later
const RiskConfidenceDetail = ({ card }) => {
  // For now, use the standard template
  // You can customize this component with specific UI for Risk & Confidence
  return <StandardAIDetail card={card} />;
};

export default RiskConfidenceDetail;
